import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import _ from "lodash";
import { Button, Col, Row } from "reactstrap";
import deleteIcon from "../assets/images/delete2.png";
import ArrowLeft from "../assets/images/left-arrow.png";
import SaveIcon from "../assets/images/plus.png";
import editIcon from "../assets/images/edit-3.png";
import editIcon2 from "../assets/images/edit2.png";
import DeleteIcon from "../assets/images/cross.png";
import sendIcon from "../assets/images/send1-shite.png";
import NotesIcon from "../assets/images/notes-icon.png";
// import ArrowDown from "../assets/images/chevron-down.svg";
// import ArrowUp from "../assets/images/chevron-up.svg";
import plusIcon from "../assets/images/plus2.png";
import clockPlus from "../assets/images/clock-plus.png";
import CommonTimeEntryIcon from "../assets/images/common-time-entry-icon.png";
import {
  deleteTimeSheetEntry,
  getMyTimeSheetDetails,
  getTimeSheetByWeek,
  // getUserDetails,
  updateMyTimeCardStatus,
  // getAllProjectList,
  DeleteMyTimeSheetDetails,
  getWeeklySummary,
  addWeeklySummary,
  upateWeeklySummary,
  getAllProjectList,
} from "../API";
import {
  convertDateToUserTimezone,
  convertMinutesToHours,
  getDayName,
  getStartEndDate,
  slashSpace,
  subtractAndAbs,
} from "../utils/utils";
import { toast } from "react-toastify";
import EditUserTimeCard from "../components/EditUserTimeCard";
import EditEquipmentTimeCard from "../components/EditEquipmentTimeCard";
import CommonTimeEntryModal from "../components/CommonTimeEntryModal";
import Loader from "./Loader";
import AddTempProjectModal from "../components/AddTempProjectModal";
import Notes from "../components/modal/Notes";
import AdditionalTimeEntryModal from "../components/modal/AdditionalTimeEntryModal";
// import TimeEntryErrorModal from "../components/modal/TimeEntryErrorModal";

export const TimeCard = () => {
  const navigate = useNavigate();
  const [projectOptions, setProjectOptions] = useState([]);
  // const [itemVisibility, setItemVisibility] = useState({});
  const [timeSheetDetails, setTimeSheetDetails] = useState({});
  const [timeSheetWeekDetails, setTimeSheetWeekDetails] = useState({});
  const [equipmentTimeSheet, setEquipmentTimeSheet] = useState({});
  const [selectedUserValue, setSelectedUserValue] = useState({});
  const [selectedEquipmentValue, setSelectedEquipmentValue] = useState({});
  const [showAddTimeButton, setShowAddTimeButton] = useState(false);
  const [addCommonCrewModal, setCommonAddCrewModal] = useState(false);
  const [addUserEditModal, setAddUserEditModal] = useState(false);
  const [addEquipmentEditModal, setAddEquipmentEditModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [listOfProjects, setListOfProjects] = useState("");
  const [editStates, setEditStates] = useState({});
  const [descriptions, setDescriptions] = useState({});
  const [notes, setNotes] = useState("");
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [isAdditionalEntryModalOpen, setIsAdditionalEntryModalOpen] =
    useState(false);
  const [selectedAdditionalUserEntry, setSelectedAdditionalUserEntry] =
    useState({});
  const [
    selectedAdditionalEquipmentEntry,
    setSelectedAdditionalEquipmentEntry,
  ] = useState({});
  const [, setFailedUserEntries] = useState([]);
  const [, setFailedEquipmentEntries] = useState([]);

  const { id } = useParams();
  const role = localStorage.getItem("role_name");
  const role_id = JSON.parse(localStorage.getItem("role_id"));
  useEffect(() => {
    setShowAddTimeButton(true);
    getDetailsofCard();
  }, []);

  const onCloseOffCanvas = () => {
    setCommonAddCrewModal(false);
  };

  const getSummary = async () => {
    const response = await getWeeklySummary(id);
    const projectsWithEditState = response?.data?.map((project) => ({
      ...project,
      isEditing: false,
      tempDescription: project?.project?.work_summary || "",
    }));

    const newDescriptions = response.data.reduce((acc, project) => {
      acc[project?.project_id] = project?.work_summary || "";
      return acc;
    }, {});

    setDescriptions(newDescriptions);
    setListOfProjects(projectsWithEditState);
  };
  const toggleEditMode = (projectId) => {
    setEditStates((prevState) => ({
      ...prevState,
      [projectId]: !prevState[projectId],
    }));
  };

  const getTimeSheetWeekDetails = async (timeSheetData) => {
    const data = {
      week: timeSheetData?.week,
      crew_id: timeSheetData?.crew_id,
    };
    await getTimeSheetByWeek(data, 1)
      .then((res) => {
        setShowAddTimeButton(false);
        setTimeSheetWeekDetails(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
    await getTimeSheetByWeek(data, 2)
      .then((res) => {
        setShowAddTimeButton(false);
        setEquipmentTimeSheet(res?.data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
      });
  };
  const handleDelete = (project) => {
    const matchedProject = listOfProjects.find(
      (p) => p?.project_id === project?.project_id
    );
    setDescriptions((prevDescriptions) => ({
      ...prevDescriptions,
      [project?.project_id]: matchedProject?.work_summary,
    }));

    toggleEditMode(project?.project_id);
  };
  const handleSave = async (data) => {
    const description =
      descriptions[data?.project_id] || data?.work_summary || "";

    const summary_id = listOfProjects?.find(
      (project) => project?.project_id === data?.project_id
    )?.id;

    try {
      let response;
      if (summary_id) {
        const payload = {
          work_summary: description,
        };
        response = await upateWeeklySummary(payload, summary_id);
      } else {
        const payload = {
          project_id: data?.project_id,
          time_sheet_id: id,
          work_summary: description,
        };
        response = await addWeeklySummary(payload);
      }

      if (response.status === 200) {
        getSummary();
        getDetailsofCard();
        toggleEditMode(data?.project_id);
        toast.success("Updated Successfully");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getDetailsofCard = async () => {
    setIsLoading(true);
    const queryParams = `id=${id}`;
    await getMyTimeSheetDetails(queryParams).then(async (res) => {
      if (res?.status === 200) {
        getSummary();
        setTimeSheetDetails(res?.data[0]);
        getTimeSheetWeekDetails(res?.data[0]);
        await getAllProjectList().then((res) => {
          const projectDropDownOptions = res?.data?.map((item) => {
            return {
              label: `(${item?.acumatica_project_id}) ${item?.description}`,
              value: item,
            };
          });
          setProjectOptions(projectDropDownOptions);
        });
        // getAllProjectList(res.data[0]?.crew?.project_id).then((res) => {
        //   setProjectDetails(res?.data[0]);
        // });
      }
    });
  };

  const getPerDayDetails = (data) => {
    return _.groupBy(data, "time_entry_date");
  };

  const cachedUserValue = useMemo(() => {
    if (timeSheetWeekDetails?.length > 0) {
      const data = getPerDayDetails(timeSheetWeekDetails);
      const dates = JSON.parse(JSON.stringify(data));
      let orderedDates = {};
      _(dates)
        .keys()
        .sort()
        .each(function (key) {
          orderedDates[key] = dates[key];
        });

      return orderedDates;
    } else {
      return {};
    }
  }, [timeSheetWeekDetails]);

  const cachedEquipmentValue = useMemo(() => {
    if (equipmentTimeSheet?.length > 0) {
      const data = getPerDayDetails(equipmentTimeSheet);
      const dates = JSON.parse(JSON.stringify(data));
      let orderedDates = {};
      _(dates)
        .keys()
        .sort()
        .each(function (key) {
          orderedDates[key] = dates[key];
        });

      return orderedDates;
    } else {
      return {};
    }
  }, [equipmentTimeSheet]);

  const cachedAllEntries = Object.keys({
    ...cachedUserValue,
    ...cachedEquipmentValue,
  }).map((date) => {
    const employees = cachedUserValue[date] || [];
    const equipment = cachedEquipmentValue[date] || [];
    return {
      [date]: [...employees, ...equipment].sort(),
    };
  });
  cachedAllEntries.sort((a, b) => {
    const dateA = Object.keys(a)[0];
    const dateB = Object.keys(b)[0];
    return new Date(dateA) - new Date(dateB);
  });
  const projectMap = new Map();

  cachedAllEntries.forEach((item) => {
    Object.values(item).forEach((entries) => {
      entries.forEach((entry) => {
        if (entry?.project_name && entry?.project_id) {
          if (!projectMap.has(entry?.project_id)) {
            projectMap.set(entry?.project_id, {
              project_name: entry?.project_name,
              project_id: entry?.project_id,
            });
          }
        }
      });
    });
  });
  const allProjects = Array.from(projectMap.values());
  const CardData = useMemo(() => {
    let cardStartDate = "";
    let cardEndDate = "";
    if (timeSheetDetails && Object?.keys(timeSheetDetails)?.length) {
      const week = timeSheetDetails?.week;
      const year = week?.split("-")[0];
      const cardWeek = week?.split("W")[1];
      const { startDate, endDate } = getStartEndDate(year, cardWeek);
      cardStartDate = startDate;
      cardEndDate = endDate;
    }
    return { cardStartDate, cardEndDate };
  }, [timeSheetDetails]);

  const onSubmitClick = async () => {
    const payload = {
      time_sheet_status_id: 2,
    };
    await updateMyTimeCardStatus(payload, id).then((res) => {
      if (res?.status === 200) {
        toast.success("Time Card Status Updated");
        navigate("/time-sheet");
      }
    });
  };
  // const toggleVisibility = (index) => {
  //   setItemVisibility((prevVisibility) => ({
  //     ...prevVisibility,
  //     [index]: !prevVisibility[index],
  //   }));
  // };

  const onCommonModalClick = (value) => {
    setCommonAddCrewModal(value);
  };

  const handleTextareaChange = (projectId, event) => {
    const { value } = event.target;

    setDescriptions((prevDescriptions) => ({
      ...prevDescriptions,
      [projectId]: value ? value : "",
    }));
  };

  const onDeleteClick = async (item) => {
    await deleteTimeSheetEntry(item?.time_entry_id)
      .then((res) => {
        if (res?.status === 204) {
          getDetailsofCard();
          toast.success("Entry Deleted Successfully");
        }
      })
      .catch(() => toast.error("Unable to delete entry"));
  };

  const onTimeSheetDeleteClick = async () => {
    const response = await DeleteMyTimeSheetDetails(id);
    if (response?.status === 204) {
      toast.success("Time Sheet Deleted Successfully");
      navigate("/time-sheet");
    }
  };

  const onUserEditClick = (item) => {
    if (item) {
      setSelectedUserValue(item);
    }
    setAddUserEditModal(true);
  };

  const onEditTeamEntry = (item) => {
    if (item) {
      setSelectedEquipmentValue(item);
    }
    setAddEquipmentEditModal(true);
  };

  const onClickNotes = (item) => {
    setNotes(item?.notes);
  };

  const onClickAdditionalTimeEntry = (item) => {
    setIsAdditionalEntryModalOpen(true);
    if (item?.time_entry_type_id === 1) {
      setSelectedAdditionalUserEntry(item);
      setSelectedAdditionalEquipmentEntry({});
    } else {
      setSelectedAdditionalEquipmentEntry(item);
      setSelectedAdditionalUserEntry({});
    }
  };

  const closeAdditionalTimeEntryModal = () => {
    setIsAdditionalEntryModalOpen(false);
  };

  const crewHeaderNames = [
    timeSheetDetails?.crew?._foreman,
    timeSheetDetails?.crew?._general_foreman,
  ].filter(Boolean);
  const canEditTimeCard =
    timeSheetDetails?.time_sheet_status_id === 0 ||
    timeSheetDetails?.time_sheet_status_id === 1;
  const weekLabel = timeSheetDetails?.week
    ? `${timeSheetDetails?.week} | ${CardData?.cardStartDate}-${CardData?.cardEndDate}`
    : "";
  const hasNoTimeCardData =
    timeSheetWeekDetails?.length <= 0 && equipmentTimeSheet?.length <= 0;

  // const handleAddJobUnit = (project) => {
  //   console.log("handleAddJobUnit", project);
  //   navigate(`/unit-job/${project.project_id}`);
  // }

  return (
    <div className="crew-mgmt">
      {!isLoading && timeSheetDetails ? (
        <>
          <div className="timecard-header">
            <div className="timecard-header-main">
              <button
                type="button"
                className="timecard-back-btn"
                aria-label="Go back"
                onClick={() => navigate(-1)}
              >
                <img alt="" src={ArrowLeft} />
              </button>

              <div className="timecard-title">
                <h1 className="timecard-crew-id">
                  {timeSheetDetails?.crew?.virtual_id}
                </h1>
                {weekLabel && (
                  <div className="timecard-meta">
                    <span className="timecard-week-pill">
                      {timeSheetDetails?.week}
                    </span>
                    <span className="timecard-dates">
                      {CardData?.cardStartDate}-{CardData?.cardEndDate}
                    </span>
                  </div>
                )}
              </div>
              {crewHeaderNames.length > 0 && (
                <div className="timecard-crew-roles">
                  {timeSheetDetails?.crew?._foreman && (
                    <div className="timecard-role">
                      <span className="timecard-role-tag">FM</span>
                      {timeSheetDetails?.crew?._foreman}
                    </div>
                  )}
                  {timeSheetDetails?.crew?._general_foreman && (
                    <div className="timecard-role">
                      <span className="timecard-role-tag">GF</span>
                      {timeSheetDetails?.crew?._general_foreman}
                    </div>
                  )}
                </div>
              )}
            </div>

            {canEditTimeCard && (
              <div className="timecard-actions">
                {role === "Admin" && role_id === 1 && (
                  <button
                    type="button"
                    className="timecard-delete-btn"
                    aria-label="Delete timesheet"
                    title="Delete timesheet"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModalCenter"
                  >
                    <img src={deleteIcon} alt="" />
                  </button>
                )}
                <div
                  className="modal centered delete-modal fade"
                  id="exampleModalCenter"
                  tabindex="-1"
                  aria-labelledby="exampleModalLabel"
                  aria-hidden="true"
                >
                  <div className="modal-dialog modal-dialog-centered ">
                    <div className="modal-content">
                      <div className="modal-body" style={{ height: "unset" }}>
                        {timeSheetWeekDetails?.length <= 0 && (
                          <p
                            style={{
                              textAlign: "center",
                              fontSize: "20px",
                              fontWeight: "600",
                            }}
                          >
                            Are you sure you want to delete this timesheet?
                          </p>
                        )}
                        {!timeSheetWeekDetails?.length <= 0 && (
                          <>
                            <p className="warning-modal-heading">Sorry!</p>
                            <p className="warning-modal-text">
                              The timesheet cannot be deleted because there are
                              time entries associated with it.
                            </p>
                          </>
                        )}
                      </div>
                      {!timeSheetWeekDetails?.length <= 0 && (
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary ok-btn"
                            data-bs-toggle="modal"
                          >
                            Ok
                          </button>
                        </div>
                      )}
                      {timeSheetWeekDetails?.length <= 0 && (
                        <div className="modal-footer">
                          <button
                            type="button"
                            className="btn btn-secondary"
                            data-bs-toggle="modal"
                          >
                            Close
                          </button>

                          <button
                            type="button"
                            className="btn btn-primary custom-delete-btn"
                            data-bs-toggle="modal"
                            onClick={onTimeSheetDeleteClick}
                          >
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <button
                  className="primary-btn me-3 add-proj-btn"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#addNewTempProject"
                >
                  <img className="sendIcon" src={plusIcon} alt="" /> Add Project
                </button>
                <button
                  onClick={() => {
                    onSubmitClick();
                  }}
                  className="primary-btn-outlined submit-btn"
                >
                  Submit{" "}
                  <img src={sendIcon} className="img-fluid" alt="eyeIcon" />
                </button>
              </div>
            )}
          </div>
          {hasNoTimeCardData && <h5 className="timecard-no-data">No Data</h5>}
          {canEditTimeCard && (
            <div className="fix-button">
              <div
                className="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#timeEntryModal"
                aria-controls="timeEntryModal"
                disabled={showAddTimeButton}
                onClick={() => onCommonModalClick(true)}
              >
                <img
                  style={{ width: "45px", height: "20px" }}
                  src={CommonTimeEntryIcon}
                  className="icon2"
                  type="button"
                  alt=""
                />
              </div>
            </div>
          )}


          {cachedAllEntries?.length > 0 &&
            cachedAllEntries?.map((dayDetails) => {
              const dateKey = _.findKey(dayDetails);
              const day = getDayName(convertDateToUserTimezone(dateKey));
              const teamHeaders = [
                "EE ID",
                "Name",
                "Project",
                "Task",
                "Cost Code",
                "Start",
                "Stop",
                "Lunch",
                "Total",
                ...(canEditTimeCard ? [""] : []),
              ];
              const equipmentHeaders = [
                "Equip. No.",
                "Item",
                "Project",
                "Task",
                "Cost Code",
                "Start",
                "Stop",
                "Break",
                "Total",
                "Offline",
                ...(canEditTimeCard ? [""] : []),
              ];

              return (
                <div className="crew-mgmt-card timecard-day-card" key={dateKey}>
                  {/* <button
                    className="collapse-btn"
                    onClick={() => toggleVisibility(index)}
                  >
                    {!itemVisibility[index] ? (
                      <img src={ArrowDown} alt="ArrowDown" />
                    ) : (
                      <img src={ArrowUp} alt="ArrowUp" />
                    )}
                  </button> */}
                  <div className="timecard-day-heading">
                    <h3>{day}</h3>
                    <span>{dateKey}</span>
                  </div>
                  {/* {!itemVisibility[index] && ( */}
                    <>
                      {cachedUserValue[dateKey]?.length > 0 && (
                        <>
                          <h2 className="heading timecard-section-heading">
                            Team Hours
                          </h2>
                          <div className="data-table-shell timecard-table-shell">
                            <table className="table table-striped tableV2 timecard-entry-table timecard-team-table">
                              <thead>
                                <tr>
                                  {teamHeaders?.map((item, key) => (
                                    <th
                                      scope="col"
                                      className="table-heading"
                                      key={key}
                                    >
                                      {item}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {cachedUserValue[dateKey] &&
                                cachedUserValue[dateKey]?.length > 0
                                  ? cachedUserValue[dateKey]?.map(
                                      (item, key) => {
                                        return (
                                          <tr key={key}>
                                              <td className="record-id">
                                                <div>
                                                  {item?.employee_id
                                                    ? item?.employee_id
                                                    : "NA"}
                                                </div>
                                              </td>
                                              <td className="timecard-person-name">
                                                {item?.name}
                                              </td>
                                              <td className="timecard-project-cell">{`(${
                                                item?.project_number
                                              }) ${slashSpace(
                                                item?.project_name
                                              )}`}</td>
                                              <td>{slashSpace(item?.task)}</td>
                                              <td>{item?.cost_code}</td>
                                              <td>{item?.time_entry_in}</td>
                                              <td>{item?.time_entry_out}</td>
                                              <td>
                                                {item?.lunch ? item?.lunch : 0}
                                              </td>
                                              <td className="timecard-total-cell">
                                                {subtractAndAbs(
                                                  item?.hours,
                                                  item?.lunch
                                                )}
                                                {item?.other_entries?.length > 0
                                                  ? "*"
                                                  : ""}
                                              </td>

                                              {canEditTimeCard ? (
                                                <td className="action-icons">
                                                  <div className="icons table-actions timecard-row-actions">
                                                    {/* <div>fdff</div> */}
                                                    {item?.other_entries
                                                      ?.length > 0 && (
                                                      <img
                                                        src={clockPlus}
                                                        // className="primary-btn me-3 add-proj-btn"
                                                        type="button"
                                                        // data-bs-toggle="modal"
                                                        // data-bs-target="#notesModal"
                                                        onClick={() =>
                                                          onClickAdditionalTimeEntry(
                                                            item
                                                          )
                                                        }
                                                        alt=""
                                                      />
                                                    )}
                                                    <img
                                                      src={NotesIcon}
                                                      // className="primary-btn me-3 add-proj-btn"
                                                      type="button"
                                                      data-bs-toggle="modal"
                                                      data-bs-target="#notesModal"
                                                      onClick={() =>
                                                        onClickNotes(item)
                                                      }
                                                      alt=""
                                                    />
                                                    <img
                                                      src={editIcon2}
                                                      data-bs-toggle="offcanvas"
                                                      data-bs-target="#editUserSideModal"
                                                      aria-controls="editUserSideModal"
                                                      className="img-fluid edit-icon"
                                                      alt=""
                                                      onClick={() =>
                                                        onUserEditClick(item)
                                                      }
                                                    />
                                                    <img
                                                      src={deleteIcon}
                                                      alt=""
                                                      className="img-fluid del-icon"
                                                      onClick={() =>
                                                        onDeleteClick(item)
                                                      }
                                                    />
                                                  </div>
                                                </td>
                                              ) : (
                                                ""
                                              )}
                                          </tr>
                                        );
                                      }
                                    )
                                  : !isLoading && <tr>No data found</tr>}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                      {cachedEquipmentValue[dateKey]?.length > 0 && (
                        <>
                          <h2 className="heading timecard-section-heading">
                            Equipment Hours
                          </h2>
                          <div className="data-table-shell timecard-table-shell">
                            <table className="table table-striped tableV2 timecard-entry-table timecard-equipment-table">
                              <thead>
                                <tr>
                                  {equipmentHeaders?.map((item, key) => (
                                    <th
                                      scope="col"
                                      className="table-heading"
                                      key={key}
                                    >
                                      {item}
                                    </th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {cachedEquipmentValue[dateKey] &&
                                cachedEquipmentValue[dateKey]?.length > 0
                                  ? cachedEquipmentValue[dateKey]?.map(
                                      (item, key) => {
                                        return (
                                          <tr key={key}>
                                            <td className="record-id">
                                              <div>{item?.acumatica_id}</div>
                                            </td>
                                            <td className="timecard-person-name">
                                              {item?.name}
                                            </td>
                                            <td className="timecard-project-cell">{`(${
                                              item?.project_number
                                            }) ${slashSpace(
                                              item?.project_name
                                            )}`}</td>
                                            <td>{slashSpace(item?.task)}</td>
                                            <td>
                                              {item?.cost_code
                                                ? item?.cost_code
                                                : "NA"}
                                            </td>
                                            <td>{item?.time_entry_in}</td>
                                            <td>{item?.time_entry_out}</td>
                                            <td>
                                              {item?.lunch ? item?.lunch : 0}
                                            </td>
                                            <td className="timecard-total-cell">
                                              {subtractAndAbs(
                                                item?.hours,
                                                item?.lunch
                                              )}
                                              {item?.other_entries?.length > 0
                                                ? "**"
                                                : ""}
                                            </td>

                                            <td>
                                              {convertMinutesToHours(
                                                item?.offline
                                              ) || 0}
                                            </td>
                                            {canEditTimeCard ? (
                                              <td className="action-icons">
                                                <div className="icons table-actions timecard-row-actions">
                                                  {item?.other_entries?.length >
                                                    0 && (
                                                    <img
                                                      src={clockPlus}
                                                      // className="primary-btn me-3 add-proj-btn"
                                                      type="button"
                                                      // data-bs-toggle="modal"
                                                      // data-bs-target="#notesModal"
                                                      onClick={() =>
                                                        onClickAdditionalTimeEntry(
                                                          item
                                                        )
                                                      }
                                                      alt=""
                                                    />
                                                  )}
                                                  <img
                                                    src={NotesIcon}
                                                    // className="primary-btn me-3 add-proj-btn"
                                                    type="button"
                                                    data-bs-toggle="modal"
                                                    data-bs-target="#notesModal"
                                                    onClick={() =>
                                                      onClickNotes(item)
                                                    }
                                                    alt=""
                                                  />
                                                  <img
                                                    data-bs-toggle="offcanvas"
                                                    data-bs-target="#editEquipmentSideModal"
                                                    aria-controls="editEquipmentSideModal"
                                                    src={editIcon2}
                                                    alt=""
                                                    className="img-fluid edit-icon"
                                                    onClick={() =>
                                                      onEditTeamEntry(item)
                                                    }
                                                  />
                                                  <img
                                                    src={deleteIcon}
                                                    alt=""
                                                    className="img-fluid del-icon"
                                                    onClick={() =>
                                                      onDeleteClick(item)
                                                    }
                                                  />
                                                </div>
                                              </td>
                                            ) : (
                                              ""
                                            )}
                                          </tr>
                                        );
                                      }
                                    )
                                  : !isLoading && <tr>No data found</tr>}
                              </tbody>
                            </table>
                          </div>
                        </>
                      )}
                    </>
                  {/* )} */}
                </div>
              );
            })}

          {cachedAllEntries?.length > 0 &&
            (timeSheetDetails?.time_sheet_status_id === 1 ||
              timeSheetDetails?.time_sheet_status_id === 0) && (
              <div className="crew-mgmt-card">
                {/* <button
                  className="btn btn-link p-0"
                  onClick={() => toggleVisibility("workSummary")}
                >
                  {itemVisibility["workSummary"] ? (
                    <img src={ArrowUp} alt="Collapse" />
                  ) : (
                    <img src={ArrowDown} alt="Expand" />
                  )}
                </button> */}
                <h3 className="title title2">Work Summary</h3>
                {/* {!itemVisibility["workSummary"] && ( */}
                  <Row className="project-item">
                    <>
                      {allProjects?.map((project, index) => {
                        const isEditable =
                          editStates[project?.project_id] || false;
                        const description =
                          descriptions[project?.project_id] || "";
                        return (
                          <>
                            <Col key={index} xs="6" sm="6" md="4" lg="3">
                              <div className="project-description">
                                <h3>{project?.project_name}</h3>

                                <textarea
                                  style={{
                                    cursor: !isEditable
                                      ? "not-allowed"
                                      : "text",
                                    outline: "none",
                                  }}
                                  onFocus={(e) =>
                                    (e.target.style.outline = "none")
                                  }
                                  onBlur={(e) =>
                                    (e.target.style.outline = "none")
                                  }
                                  onMouseDown={(e) =>
                                    (e.target.style.outline = "none")
                                  }
                                  value={description}
                                  placeholder="Enter description here"
                                  readOnly={!isEditable}
                                  onChange={(event) =>
                                    handleTextareaChange(
                                      project?.project_id,
                                      event
                                    )
                                  }
                                />
                                <div className="d-flex justify-content-between">
                                  {isEditable && (
                                    <>
                                      <Button
                                        className="primary-solid"
                                        onClick={() => handleSave(project)}
                                      >
                                        <img
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleSave(project);
                                          }}
                                          className="edit-logo"
                                          src={SaveIcon}
                                          alt=""
                                        />
                                        Save
                                      </Button>

                                      {/* <Button onClick={() => handleAddJobUnit(project)} className="primary-outline">
                                        Add unit Job
                                      </Button> */}

                                      <Button
                                        className="primary-outline"
                                        onClick={() => handleDelete(project)}
                                        outline
                                      >
                                        <img
                                          className="edit-logo"
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleDelete(project);
                                          }}
                                          src={DeleteIcon}
                                          alt=""
                                        />
                                        Cancel
                                      </Button>
                                    </>
                                  )}
                                  {!isEditable && (
                                    <Button
                                      className="primary-outline"
                                      onClick={() =>
                                        toggleEditMode(project?.project_id)
                                      }
                                      outline
                                    >
                                      <img
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          toggleEditMode(project?.project_id);
                                        }}
                                        className="edit-logo"
                                        src={editIcon}
                                        alt=""
                                      />{" "}
                                      Edit
                                    </Button>
                                  )}
                                </div>
                              </div>
                            </Col>
                          </>
                        );
                      })}
                    </>
                  </Row>
                {/* )} */}
              </div>
            )}

          <AddTempProjectModal
            virtualId={timeSheetDetails?.crew?.virtual_id}
            getTimeSheetWeekDetails={getTimeSheetWeekDetails}
            timeSheetDetails={timeSheetDetails}
            type="timecard"
          />
          <CommonTimeEntryModal
            toggleModalFunc={onCloseOffCanvas}
            crew_id={timeSheetDetails?.crew_id}
            project_id={timeSheetDetails?.crew?.project_id}
            addCrewModal={addCommonCrewModal}
            onModalClick={onCommonModalClick}
            entryType={"both"}
            getTimeSheetWeekDetails={getTimeSheetWeekDetails}
            timeSheetDetails={timeSheetDetails}
            isErrorModal={isErrorModal}
            setIsErrorModal={setIsErrorModal}
            setFailedUserEntries={setFailedUserEntries}
            setFailedEquipmentEntries={setFailedEquipmentEntries}
          />

          <Notes notes={notes} setNotes={setNotes} />

          <EditUserTimeCard
            defaultNotes={notes}
            crew_id={timeSheetDetails?.crew_id}
            project_id={timeSheetDetails?.crew?.project_id}
            addCrewModal={addUserEditModal}
            selectedUserValue={selectedUserValue}
            onModalClick={onUserEditClick}
            entryType={"user"}
            getTimeSheetWeekDetails={getTimeSheetWeekDetails}
            timeSheetDetails={timeSheetDetails}
            projectOptions={projectOptions}
          />
          <EditEquipmentTimeCard
            defaultNotes={notes}
            notes={notes}
            crew_id={timeSheetDetails?.crew_id}
            project_id={timeSheetDetails?.crew?.project_id}
            addCrewModal={addEquipmentEditModal}
            selectedUserValue={selectedEquipmentValue}
            onModalClick={onUserEditClick}
            entryType={"equipment"}
            getTimeSheetWeekDetails={getTimeSheetWeekDetails}
            timeSheetDetails={timeSheetDetails}
            projectOptions={projectOptions}
          />
          <AdditionalTimeEntryModal
            isOpen={isAdditionalEntryModalOpen}
            closeModal={closeAdditionalTimeEntryModal}
            selectedUserEntry={selectedAdditionalUserEntry}
            selectedEquipmentEntry={selectedAdditionalEquipmentEntry}
          />
          {/* <TimeEntryErrorModal
            isErrorModal={isErrorModal}
            setIsErrorModal={setIsErrorModal}
            failedUserEntries={failedUserEntries}
            setFailedUserEntries={setFailedUserEntries}
            failedEquipmentEntries={failedEquipmentEntries}
            setFailedEquipmentEntries={setFailedEquipmentEntries}
          /> */}
        </>
      ) : (
        <Loader />
      )}
    </div>
  );
};

export default TimeCard;